import SVGIconBase from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
const HomeIcon = props => /*#__PURE__*/_jsx(SVGIconBase, Object.assign({
  "data-test-id": "vertical-nav-icon__home"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M29.2,31.13h-8.87c-.54,0-.99-.43-1-.98l-.19-8.1h-6.48v8.08c0,.55-.45,1-1,1H2.8c-.27,0-.52-.11-.71-.29-.19-.19-.29-.44-.29-.71l.08-16.74c0-.29.12-.56.34-.75L15.34,1.12c.38-.33.94-.33,1.32,0l13.2,11.51c.22.19.34.46.34.75v16.74c0,.55-.45,1-1,1ZM21.31,29.13h6.9v-15.29L16,3.2,3.88,13.84l-.08,15.29h6.86v-8.08c0-.55.45-1,1-1h8.46c.54,0,.99.43,1,.98l.19,8.1Z"
  })
}));
export default HomeIcon;